import { getVisiblePathMidpointWithNormal } from './getVisiblePathMidpoint';

const EDGE_HITBOX_HALF = 12; // matches flowchart__edge-hitbox ~24px screen width
const EDGE_INSERT_VISUAL_OFFSET = 18;
const EDGE_INSERT_HIT_OFFSET = EDGE_HITBOX_HALF + 14; // 26px — clears hitbox + generous target
const EDGE_INSERT_HIT_SIZE = 28;
// Invisible corridor from edge hitbox to (+) — centered on the gap so it works at any angle
const EDGE_INSERT_ZONE_START = EDGE_HITBOX_HALF - 2;
const EDGE_INSERT_ZONE_END = EDGE_INSERT_HIT_OFFSET + EDGE_INSERT_HIT_SIZE / 2;

export const EDGE_INSERT_ZONE_LENGTH = EDGE_INSERT_ZONE_END - EDGE_INSERT_ZONE_START;
export const EDGE_INSERT_ZONE_WIDTH = EDGE_INSERT_HIT_SIZE + 4;

/** Screen placement for one edge's (+) button, or null when the edge has no visible midpoint. */
export function layoutEdgeInsert(edge, { pan, zoom, containerRect, canvasToScreen }) {
  if (edge.isMilestoneStub || edge.isNoteStem) return null;
  const midpoint = getVisiblePathMidpointWithNormal(
    edge.pathD,
    pan,
    zoom,
    containerRect ? { width: containerRect.width, height: containerRect.height } : null,
  );
  if (!midpoint) return null;

  const zoneMidDist = (EDGE_INSERT_ZONE_START + EDGE_INSERT_ZONE_END) / 2;
  return {
    screenPos: canvasToScreen(midpoint.x, midpoint.y),
    midpoint,
    visualOffsetX: midpoint.normalX * EDGE_INSERT_VISUAL_OFFSET,
    visualOffsetY: midpoint.normalY * EDGE_INSERT_VISUAL_OFFSET,
    zoneMidX: midpoint.normalX * zoneMidDist,
    zoneMidY: midpoint.normalY * zoneMidDist,
    zoneAngleDeg: Math.atan2(midpoint.normalY, midpoint.normalX) * (180 / Math.PI),
  };
}
